<template>
  <div>
    <u-field
      :label="$t('_.username')"
      :vname="$t('_.username').toString().toLowerCase()"
      vid="username"
      mode="passive"
      rules="required"
    >
      <b-input
        v-model="form.username"
        :disabled="isProcessing"
        :placeholder="$t('_placeholder.your_username')"
        autocomplete="username"
        autofocus
        type="text"
      />
    </u-field>
    <u-field
      :label="$t('_.password')"
      :vname="$t('_.password').toString().toLowerCase()"
      vid="password"
      mode="passive"
      rules="required"
    >
      <b-input
        v-model="form.password"
        :disabled="isProcessing"
        :placeholder="$t('_.your_password')"
        autocomplete="current-password"
        type="password"
      />
    </u-field>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { IClientAuthProviderForm } from "@/models/providers/clientAuth";

export default defineComponent({
  name: "ClientAuthLoginFields",
  props: {
    value: {
      type: Object as PropType<IClientAuthProviderForm>,
      required: true
    },
    isProcessing: { type: Boolean, default: false }
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
});
</script>
